import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-n fac account-tab" }
const _hoisted_2 = { class: "list-content" }
const _hoisted_3 = { class: "flex-n" }
const _hoisted_4 = { class: "flex-1 ml-10" }
const _hoisted_5 = { class: "flex-n fac mt-20" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-n" }
const _hoisted_9 = { class: "flex-n fac mt-20" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import {onMounted, ref, watch} from "vue";
import {useRouter, useRoute} from 'vue-router'
import weChatMerchantMemberApi from "@/utils/Api/WeChatMerchantMember"
import dic from "@/assets/ts/dictionary";
import TabContent from "@/components/TabContent/TabContent.vue";
import employeeApi from "@/utils/Api/Employee";


export default /*@__PURE__*/_defineComponent({
  __name: 'accountlist',
  setup(__props) {

const chooseTab=ref(0);
const menuList=[{
  label:'企业',
  value:0
},{
  label:'个人',
  value:1
}]

onMounted(() => {
  document.title = '入会申请列表';
  // getDataList();
})

const router = useRouter();
const route = useRoute();
const refreshing = ref(false);
const list: any = ref([]);
const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);

watch(()=>chooseTab.value,(newval)=>{
  console.log(newval)
  onRefresh();
})
const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  onLoad();
};
const onLoad = () => {
  pageNo.value++;
  console.log(pageNo.value)
  if(chooseTab.value==0){
    weChatMerchantMemberApi.list(pageNo.value, {}).then(res => {
      console.log(res)
      if(res.data){
        list.value = list.value.concat(res.data?.data || []);
        if (list.value.length >= res.data.dataCount) {
          finished.value = true;
        }
      }else {
        list.value =[]
        finished.value = true;
      }
    }).finally(() => {
      loading.value = false;
      refresh.value = false;
    })
  }else{
    employeeApi.list(pageNo.value, {}).then(res => {
      console.log(res)
      if(res.data){
        list.value = list.value.concat(res.data?.data || []);
        if (list.value.length >= res.data.dataCount) {
          finished.value = true;
        }
      }else {
        list.value =[]
        finished.value = true;
      }
    }).finally(() => {
      loading.value = false;
      refresh.value = false;
    })
  }

};


// const gotoPage = (id: string,type:string|number,look?:boolean) => {
//   router.push('/accountdetail?id=' + id+'&type='+type+(look?('&look='+look):''))
// }

const gotoPage = (path:string|number,id: string,look?:boolean) => {
  router.push('/'+path+'?id=' + id+(look?('&look='+look):''))
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "入会申请列表",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TabContent, {
        modelValue: chooseTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((chooseTab).value = $event)),
        list: menuList
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: onLoad,
            class: "list-content"
          }, {
            default: _withCtx(() => [
              (chooseTab.value==0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(list.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        (item.merchantCategory==2)
                          ? (_openBlock(), _createBlock(_component_van_tag, {
                              key: 0,
                              type: "primary"
                            }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("企业")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (item.merchantCategory==3)
                          ? (_openBlock(), _createBlock(_component_van_tag, {
                              key: 1,
                              color: "success"
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode("墓园")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (item.merchantCategory==4)
                          ? (_openBlock(), _createBlock(_component_van_tag, {
                              key: 2,
                              type: "warning"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("殡仪馆")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(item.merchantCategory==1?item.contactName:item.companyName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex-1", 'state'+item.auditStatus ])
                        }, _toDisplayString(_unref(dic).getDicText('approvalStatus', item.auditStatus)), 3),
                        (item.auditStatus==3)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "btn",
                              onClick: ($event: any) => (gotoPage('accountdetail',item.id))
                            }, "编辑", 8, _hoisted_6))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "btn",
                              onClick: ($event: any) => (gotoPage('accountdetail',item.id,true))
                            }, "查看", 8, _hoisted_7))
                      ])
                    ]))
                  }), 128))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(list.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.username), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex-1", 'state'+item.auditStatus ])
                        }, _toDisplayString(_unref(dic).getDicText('approvalStatus', item.auditStatus)), 3),
                        (item.auditStatus==3)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "btn",
                              onClick: ($event: any) => (gotoPage('personapplydetail',item.id))
                            }, "编辑", 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "btn",
                              onClick: ($event: any) => (gotoPage('personapplydetail',item.id,true))
                            }, "查看", 8, _hoisted_11))
                      ])
                    ]))
                  }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})